import React, {Fragment} from 'react';
import {Form} from 'react-final-form';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import {Text, Select, Popup, Explanation_text} from '../../../components';
import {Field} from 'react-final-form';
import {connect} from 'react-redux';

function Update_user_popup(props){

  function onSubmit(params){
    props.updateTeamMember(params.id, params);
  }

  let current_subscription={};
  for(let s of props.subscriptions){if(props.workspace.active_subscription!=undefined && s.id==props.workspace.active_subscription.prospect_safari_service_id){current_subscription=s;}}
  let amount=current_subscription.amount;
  let interval='month'; if(current_subscription.subscription_interval=='YEAR'){interval='year';}
  let cost=current_subscription.currency+amount;
  let already_paid=false; if(props.workspace.active_subscription!=undefined && props.workspace.active_subscription.quantity>props.current_user_count){already_paid=true;}
  return(
    <Form
      onSubmit={onSubmit}
      initialValues={{id:props.initialValues.id, admin:props.initialValues.admin}}
    >
      {form_props => (
        <form onsubmit={form_props.handleSubmit}>
        <Popup accept_button={(props.no_extra==true)?undefined:(props.initialValues.new==true || props.initialValues.user_id==undefined)?'Invite':'Submit'} handleClose={props.handleClose} accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose();}} always_open title='team_setup_update_popup_title' content={
          <div style={{width:'600px', marginTop:'30px', marginBottom:'30px'}}>
          <Typography color="primary" style={{width:'calc(100% -60px)', marginLeft:'30px', marginBottom:'30px', textAlign:'center'}}>{
            (props.no_extra==true)?"You are not able to add a new user to your account because you have already reached the limit defined by your subscription."
            :(props.initialValues.new==true || props.initialValues.user_id==undefined)?
            (already_paid==true)?"Your current subscription includes "+props.workspace.active_subscription.quantity+" active users therefore you won't incur any extra charges. (The cost per active user is "+cost+" a "+interval+")."
            :<Fragment>{"Your current subscription includes "+props.workspace.active_subscription.quantity+" active users. Remember that once your new team member accepts your invitation, you will incur an extra cost of "+cost+" a "+interval+"."}<div style={{marginTop:'20px', color:"rgba(0, 0, 0, 0.87)"}}>If you don't wish to increase your user count and therefore incur an extra cost, you should first remove one of your current active users.</div></Fragment>
            :"Remember that admins have access to every aspect of the workspace."}</Typography>
        <Grid container style={{width:'calc(100% - 60px)', marginLeft:'30px'}}>
          <Grid item xs={12} sm={6} style={{paddingLeft:'10px'}}><Field name='admin'>{(f)=><FormControlLabel control={<Checkbox checked={f.input.value} onChange={f.input.onChange}/>} label={<Explanation_text inline text="team_setup_update_admin_label"/>}/>}</Field></Grid>
        </Grid>
    </div>
  }/>
    </form>
  )}</Form>
  )
}

function Delete_user_popup(props){

  return(
    <Popup style={{marginTop:'-30px'}} accept_button={'Remove'} handleClose={props.handleClose} accept_button_click={()=>{props.deleteTeamMember(props.uw.id)}} always_open title='delete_user_popup_title' content={
          <div style={{width:'600px', marginTop:'30px', marginBottom:'30px'}}>
          <Typography style={{width:'calc(100% - 40px)', marginLeft:'20px'}}><Explanation_text text='delete_user_explanation_text' placeholders={{workspace:props.workspace.name}} inline/></Typography>
          </div>
  }/>
  )
}



function User_popup(props){
    if(props.delete==true){return(<Delete_user_popup {...props}/>)}
    else{return(<Update_user_popup {...props}/>)}
}

export default connect(ss,dd)(User_popup);

function ss(state){
  return{
    subscriptions:state.account.subscriptions,
    refresh:state.workspaces.refresh,
    workspace:(state.workspaces.data==undefined)?undefined:state.workspaces.data[state.workspaces.current_workspace_id]
  }
}

function dd(dispatch){
  return{
    deleteTeamMember:(id, data)=>{dispatch({type:'REQUEST_DELETE_TEAM_MEMBER', id:id});},
    updateTeamMember:(id, data)=>{dispatch({type:'REQUEST_UPDATE_TEAM_MEMBER', id:id, payload:data});}
  }
}
